import React from 'react';
import { Divider, Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { LineDirectory } from '@paragon/contract-library';

import {
  showCreateDirectoryDialog,
  showCreateLineDialog,
  showEditDirectoryDialog,
} from '../../../actions/dialogActions';
import { deleteDirectory } from '../../../actions/supervisorActions';
import { useAppDispatch } from '../../hooks';

export function DirectoryMenu(props: { directory: LineDirectory; anchor: MenuAnchor; onClose: () => void }) {
  const dispatch = useAppDispatch();

  return (
    <Menu open={props.anchor != null} {...getAnchorProps(props.anchor)} onClose={props.onClose}>
      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(showEditDirectoryDialog(props.directory.guid));
        }}
      >
        Edit directory
      </MenuItem>
      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(deleteDirectory(props.directory.guid));
        }}
      >
        Delete directory
      </MenuItem>

      <Divider />

      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(showCreateDirectoryDialog(props.directory.guid));
        }}
      >
        Create sub-directory
      </MenuItem>
      <MenuItem
        onClick={() => {
          props.onClose();
          dispatch(showCreateLineDialog(props.directory.guid));
        }}
      >
        Create line in directory
      </MenuItem>
    </Menu>
  );
}
